import React, { createContext, useState } from "react";

export const SearchMarketingActionPlanContext = createContext({});

export const initialSearchValues = {
  currentCustomerId: "",
  factoryName: "",
  typeOfEstate: [],
  customerGroupByEstateType: [],
  yearOfBudget: [],
  monthOfBudget: [],
  customerGroupByAge: [],
  customerGroupByRegion: [],
  waterConsumptionMin: "",
  waterConsumptionMax: "",
  areaSizeByRaiMin: "",
  areaSizeByRaiMax: "",
  areaSizeByNganMin: "",
  areaSizeByNganMax: "",
  areaSizeByWaMin: "",
  areaSizeByWaMax: "",
  areaSizeByMetersMin: "",
  areaSizeByMetersMax: "",
  buyOrRentLand: "",
  productAndServiceWant: "",
  supportWant: "",
  transactionWant: "",
  crmExpected: "",
  lineOfWorkId: [],
};

export const initialPageValues = {
  page: 0,
  pageSize: 1,
  total: 0,
  totalPage: 0,
  // sortBy: "currentCustomerId",
  sortBy: "createDate",
  sortDirection: "DESC",
};

const SearchMarketingActionPlanProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchMarketingActionPlanContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchMarketingActionPlanContext.Provider>
  );
};

export default SearchMarketingActionPlanProvider;
